import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 保存类型
 */
class SaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
}

export const SAVE_TYPE = new SaveType();

/**
 * 数据库只有签署中和确认中的状态 其他用来查询
 * 出库状态 进销存和仓储监控 新增方 用
 */
class Status extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    CONFIRMING = new Meta(2, "确认中");
    TO_BE_INITIATED = new Meta(3, "待发起");
    TO_BE_SIGN = new Meta(4, "待签署");
    SIGNING = new Meta(5, "签署中");
    REJECTED = new Meta(6, "已驳回");
    OUTBOUND = new Meta(7, "已出库");
    INVALIDED = new Meta(8, "作废中");
    INVALID = new Meta(9, "已作废");
}

export const STATUS = new Status();

/**
 * 数据库只有签署中和确认中的状态 其他用来查询
 * 出库状态 进销存 新增方 用
 */
class StatusAdmin extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    CONFIRMING = new Meta(2, "确认中");
    TO_BE_INITIATED = new Meta(3, "待发起");
    TO_BE_SIGN = new Meta(4, "待签署");
    SIGNING = new Meta(5, "签署中");
    REJECTED = new Meta(6, "已驳回");
    // 进销存 新增出库 为录入的才有这个
    TO_BE_OUTBOUND = new Meta(11, "待出库");
    OUTBOUND = new Meta(7, "已出库");
    INVALIDED = new Meta(8, "作废中");
    INVALID = new Meta(9, "已作废");
}

export const STATUS_ADMIN = new StatusAdmin();

/**
 * 出库状态 进销存和仓储监控 非新增方 查询用
 */
class StatusPc extends UltMeta {
    TO_BE_CONFIRM = new Meta(10, "待确认");
    TO_BE_SIGN = new Meta(4, "待签署");
    SIGNING = new Meta(5, "签署中");
    OUTBOUND = new Meta(7, "已出库");
    INVALIDED = new Meta(8, "作废中");
    INVALID = new Meta(9, "已作废");
}

export const STATUS_PC = new StatusPc();

/**
 * 签署方式
 */
class SignMode extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const SIGN_MODE = new SignMode();

/**
 * 出库类型
 */
class OutboundType extends UltMeta {
    SELLER_OUTBOUND = new Meta(1, "销售出库");
    ALLOT_OUTBOUND = new Meta(2, "调拨出库");
    USE_OUTBOUND = new Meta(3, "领用出库");
    INVENTORY_LOSS_OUTBOUND = new Meta(4, "盘亏出库");
    REJECT_GOODS_OUTBOUND = new Meta(5, "退货出库");
    SCRAP_OUTBOUND = new Meta(6, "报废出库");
    OTHER_OUTBOUND = new Meta(7, "其他出库");
}

export const OUTBOUND_TYPE = new OutboundType();
